import {Box, BoxProps, Text} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {FC} from 'react';
import LinkUI from 'ui/LinkUI';

interface Props extends BoxProps {
  name: string;
}

export const Tag: FC<Props> = ({name, ...props}) => {
  return (
    <LinkUI
      href={{
        pathname: `/search`,
        query: {query: `${name}`},
      }}
    >
      <Box
        border="1px solid"
        borderColor={colors.borderGray}
        borderRadius="16px"
        pb={['6px', '9px']}
        px={['10px', '20px']}
        pt={['4px', '9px']}
        cursor="pointer"
        _hover={{borderColor: colors.black}}
        _first={{
          ml: ['15px', '30px'],
        }}
        _last={{
          mr: ['15px', '30px'],
        }}
        {...props}
      >
        <Text as="span" fontSize={['12px', '16px']} fontWeight="600" color={colors.black} whiteSpace="nowrap">
          {name}
        </Text>
      </Box>
    </LinkUI>
  );
};
